import {advisorProfile, clientURL, managerProfile} from "../url";
import _ from "lodash";

const checkProfilePassword= (search) => async () =>
{
    const queryParams = search ? _.reduce(search.substring(1).split("&"),
        (result, value) => {
            let params = value.split("=");
            result[params[0]] = params[1];
            return result;
        }, {}) : {};
    if(queryParams.profile===advisorProfile+'' || queryParams.profile===managerProfile+'')
        window.location.href=clientURL +'restore-password' + search;
};
export default checkProfilePassword;